module.exports = __webpack_public_path__ + "media/components/assets/images/cooingklePackage/image3_after_sale2-f3e278e7f6dbc7633c9b654310d3de74.png";